<app-common-modal-wrapper
  icon="ic-refresh-20"
  header="Update Contact Details"
  [isLoading]="isLoading()"
  [isDisabled]="selectedContacts.length == 0"
  (close)="close()"
  (submitModal)="submit()"
>
  <div class="actions">
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center gap-8"
      [disabled]="isLoading()"
      (click)="onAddContact()"
    >
      <i class="icon ic-add-20"></i>
      <span>Add Contact</span>
    </button>
  </div>

  @if (isLoading()) {
    <app-loader/>
  } @else {
    <app-list-grid-client-side
      rowSelection="single"
      [colDefs]="colDefs"
      [rowData]="viewContacts()"
      [isFullWidthRow]="isFullWidthRow"
      [fullWidthCellRenderer]="fullWidthCellRenderer"
      [getRowHeight]="getRowHeight"
      [gridOptions]="gridOptions"
      (select)="onSelectContacts($event)"
    />
  }
</app-common-modal-wrapper>
